module.exports = __webpack_public_path__ + "ffc77b2ae5c435c02b30d8e61dda26cd.MP3";